import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'

import { displayMessages } from './common'

export function getGrupos(page = 1) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const showRecords = getState().grupos.get('showRecords')
		const orderBy = getState().grupos.get('orderBy')
		const filters = getState().grupos.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()

        const fn0 = () => axios.get(`${API_URL}/grupos`, { params: { page, showRecords, orderBy, filters, full: true }})
        const fn1 = () => axios.get(`${API_URL}/permisos`)

        Promise.all([fn0(), fn1()])
		.then((res) => {
			const data = res[0].data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
            const totalRecords = Number(res[0].data.totalRecords)
            const permisos = res[1].data
			const fn3 = d => d({ type: types.OBTENER_GRUPOS, payload: { data, page, totalRecords, permisos } })
			fn3(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}

export function filterGrupos(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_GRUPOS, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().grupos.get('orderBy')
		current = current.set('field', field.value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}

        const fn0 = (d) => d({ type: types.ORDENAR_GRUPOS, payload: { orderBy: current } })
        const fn1 = (d) => d(getGrupos(1))
        fn0(dispatch)
        fn1(dispatch)
	}
}

export function displayModalCreate(show, title, mode, index = null) {
	return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CREAR_GRUPO, payload: { show, title, mode, index } })
	}
}

export function updateInputsInModalCreate(attr, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS, payload: { attr, value } })
	}
}

export function selectItem(index) {
	return (dispatch) => {
		dispatch({ type: types.SELECCIONAR_ITEM_GRUPOS, payload: index })
	}
}

export function createOrUpdateGrupos(data, mode) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		if (getState().grupos.getIn(['modalCreate','data','reporta_a','id']) === getState().common.getIn(['user','id'])) {
			displayMessages(dispatch, { warning: 'El grupo al que reporta no puede ser el mismo grupo' })
		} else {
			const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_GRUPOS, payload: true })
			const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_GRUPOS, payload: false })
			fn0(dispatch)
			if (mode === 'create') {
				axios.post(`${API_URL}/grupos`, data.toJS())
					.then(res => {
						const grupo = res.data
						grupo.visible = true
						grupo.selected = false
						dispatch({ type: types.CREAR_ACTUALIZAR_GRUPO, payload: grupo })
						displayMessages(dispatch, { success: 'El grupo ha sido guardado exitosamente' })
						fn1(dispatch)
					})
					.catch(err => {
						console.log(err)
						displayMessages(dispatch, err)
						fn1(dispatch)
					})
			} else if (mode === 'edit') {
				axios.put(`${API_URL}/grupos/${data.get('id')}`, data.toJS())
					.then(res => {
						const grupo = res.data
						grupo.visible = true
						grupo.selected = false
						dispatch({ type: types.CREAR_ACTUALIZAR_GRUPO, payload: grupo })
						displayMessages(dispatch, { success: 'El grupo ha sido actualizado exitosamente' })
						fn1(dispatch)
					})
					.catch(err => {
						console.log(err)
						displayMessages(dispatch, err)
						fn1(dispatch)
					})
			}
		}
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO, payload: { open, message, action } })
	}
}

export function deleteGrupos() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().grupos.get('grupos').filter(x => x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/grupos/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.Nombre)
					dispatch({ type: types.ELIMINAR_GRUPO, payload: x.result.data.id })
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes grupos: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})
	}
}

export function showHideModalFilter(state) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS, payload: state })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_GRUPOS })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_GRUPOS })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_GRUPOS, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_GRUPOS })
        const fn1= (d) => d(getGrupos(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function updateInputs(path, value, immutable = true) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_GRUPOS, payload: { path, value, immutable } })
		fn1(dispatch)
	}
}

export function toggleSelectAll(checked) {
	return (dispatch, getState) => {
        const permisosGrupo = getState().grupos.get('permisosGrupo')
        permisosGrupo.forEach((x, n) => {
            const path = `permisosGrupo.${n}.selected`
            dispatch(updateInputs(path, checked, false))
        })
	}
}

export function storePermisosGrupo() {
	const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const grupo = getState().grupos.getIn(['grupos',String(getState().grupos.get('selected'))])
        const selected = getState().grupos.get('permisosGrupo').filter(x => x.get('selected')).map(x => x.get('id'))
        const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_GRUPOS, payload: true })
        const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_GRUPOS, payload: false })
        fn0(dispatch)

        axios.put(`${API_URL}/grupos/${grupo.get('id')}/permisos`, { permisos: selected.toJS() })
        .then(res => {
            displayMessages(dispatch, { success: 'El grupo ha sido actualizado exitosamente' })
            fn1(dispatch)
        })
        .catch(err => {
            console.log(err)
            displayMessages(dispatch, err)
            fn1(dispatch)
        })

    }
}


// WEBPACK FOOTER //
// ./src/actions/grupos.js